import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQualificationBaselineValidationDark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 141,
	viewBox: "0 0 412 141",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 66.7083,
			y2: -.45,
			transform: "matrix(-0.974391 -0.22486 -0.22486 0.974391 82 113)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 25.6125,
			y2: -.45,
			transform: "matrix(0.624695 -0.780869 -0.780869 -0.624695 95 109)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3236,
			y2: -.45,
			transform: "matrix(0.914918 0.40364 0.40364 -0.914918 123 86)",
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 88C13.4183 88 17 91.5817 17 96C17 100.418 13.4183 104 8.99999 104C4.58171 104 1 100.418 1 96C1 91.5817 4.58171 88 8.99999 88Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M8.99999 93C10.6568 93 12 94.3431 12 96C12 97.6569 10.6568 99 8.99999 99C7.34313 99 6 97.6569 6 96C6 94.3431 7.34313 93 8.99999 93Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116 75C120.418 75 124 78.5817 124 83C124 87.4183 120.418 91 116 91C111.582 91 108 87.4183 108 83C108 78.5817 111.582 75 116 75Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116 80C117.657 80 119 81.3431 119 83C119 84.6569 117.657 86 116 86C114.343 86 113 84.6569 113 83C113 81.3431 114.343 80 116 80Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90 106.999C94.4183 106.999 98 110.581 98 114.999C98 119.417 94.4183 122.999 90 122.999C85.5817 122.999 82 119.417 82 114.999C82 110.581 85.5817 106.999 90 106.999Z",
			stroke: "#414144",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M90 111.999C91.6569 111.999 93 113.342 93 114.999C93 116.656 91.6569 117.999 90 117.999C88.3431 117.999 87 116.656 87 114.999C87 113.342 88.3431 111.999 90 111.999Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 284.607,
			y1: 12.4143,
			x2: 216.176,
			y2: 41.4143,
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 339.943,
			y1: 77.5536,
			x2: 394.943,
			y2: 70.5536,
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 297.394,
			y1: 14.7821,
			x2: 328.394,
			y2: 70.7821,
			stroke: "#414144",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 86C336.418 86 340 82.4183 340 78C340 73.5817 336.418 70 332 70C327.582 70 324 73.5817 324 78C324 82.4183 327.582 86 332 86Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 81C333.657 81 335 79.6569 335 78C335 76.3431 333.657 75 332 75C330.343 75 329 76.3431 329 78C329 79.6569 330.343 81 332 81Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 78C407.418 78 411 74.4183 411 70C411 65.5817 407.418 62 403 62C398.582 62 395 65.5817 395 70C395 74.4183 398.582 78 403 78Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 73C404.657 73 406 71.6569 406 70C406 68.3431 404.657 67 403 67C401.343 67 400 68.3431 400 70C400 71.6569 401.343 73 403 73Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 17C296.418 17 300 13.4183 300 9C300 4.58172 296.418 1 292 1C287.582 1 284 4.58172 284 9C284 13.4183 287.582 17 292 17Z",
			stroke: "#414144",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292 12C293.657 12 295 10.6569 295 9C295 7.34315 293.657 6 292 6C290.343 6 289 7.34315 289 9C289 10.6569 290.343 12 292 12Z",
			fill: "#4C361A"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M353.3 37.65C353.3 39.67 351.67 41.3 349.65 41.3C347.63 41.3 346 39.67 346 37.65C346 35.63 347.63 34 349.65 34C351.67 34 353.3 35.63 353.3 37.65Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M148.903 40.4712C148.433 35.1584 152.358 30.47 157.671 29.9994L263.686 20.6095C268.999 20.139 273.688 24.0644 274.158 29.3773L282.282 121.099C282.753 126.412 278.827 131.101 273.514 131.571L167.499 140.961C162.186 141.432 157.498 137.506 157.027 132.193L148.903 40.4712Z",
			fill: "#1C1C1E"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 141.413,
			y: 19.5408,
			width: 132.41,
			height: 109.719,
			rx: 7.55,
			fill: "#3F3F41",
			stroke: "#6E6E6E",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M142.375 27.5088C142.375 23.6428 145.509 20.5088 149.375 20.5088H265.848C269.714 20.5088 272.848 23.6428 272.848 27.5088V45.0362C272.848 45.5884 272.4 46.0362 271.848 46.0362H143.375C142.823 46.0362 142.375 45.5884 142.375 45.0362V27.5088Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 207.163,
			y1: 59.2508,
			x2: 199.554,
			y2: 59.2508,
			stroke: "#868686",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 212.839,
			y1: 63.5057,
			x2: 199.557,
			y2: 63.5057,
			stroke: "#868686",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 170.29,
			y1: 84.7771,
			x2: 162.681,
			y2: 84.7771,
			stroke: "#868686",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 175.968,
			y1: 89.0311,
			x2: 162.686,
			y2: 89.0311,
			stroke: "#868686",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 170.29,
			y1: 108.888,
			x2: 162.681,
			y2: 108.888,
			stroke: "#868686",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 175.968,
			y1: 113.14,
			x2: 162.686,
			y2: 113.14,
			stroke: "#868686",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 244.036,
			y1: 108.888,
			x2: 236.427,
			y2: 108.888,
			stroke: "#868686",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 249.714,
			y1: 113.14,
			x2: 236.432,
			y2: 113.14,
			stroke: "#868686",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			opacity: .7,
			x1: 189.63,
			y1: 53.576,
			x2: 189.63,
			y2: 119.331,
			stroke: "#2F2E2E",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 278.975,
			y1: 28.0486,
			x2: 278.975,
			y2: 56.9306,
			stroke: "#EAEAEA",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			opacity: .7,
			x1: 226.503,
			y1: 53.576,
			x2: 226.503,
			y2: 119.331,
			stroke: "#2F2E2E",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			opacity: .7,
			x1: 259.64,
			y1: 73.4324,
			x2: 155.594,
			y2: 73.4324,
			stroke: "#2F2E2E",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			opacity: .7,
			x1: 259.64,
			y1: 98.9598,
			x2: 155.594,
			y2: 98.9598,
			stroke: "#2F2E2E",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M251.044 78.6543H248.285L248.119 78.656C247.61 78.647 247.425 78.844 247.273 79.0871L245.106 82.4184L243.03 79.1541L242.961 79.0471C242.961 79.0471 242.904 78.9516 242.805 78.9481H242.804C242.704 78.9516 242.648 79.0471 242.648 79.0471L242.579 79.1541L240.573 82.4184L238.336 79.0871C238.183 78.844 237.998 78.647 237.489 78.656L237.323 78.6543H234.564L234.564 81.3744H236.189C236.532 81.3711 236.69 81.3877 236.925 81.6801L237.023 81.828L240.305 87.1544C240.305 87.1544 240.412 87.3263 240.593 87.3274C240.789 87.3281 240.897 87.1539 240.897 87.1539L242.808 84.182H242.808L244.796 87.1499C244.796 87.1499 244.908 87.3259 245.077 87.3303C245.258 87.335 245.358 87.1539 245.358 87.1539L248.59 81.828L248.686 81.6801C248.855 81.4075 249.066 81.379 249.408 81.3823L251.034 81.3813L251.044 78.6543Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M246.889 86.2156L245.122 89.124L242.843 85.6974L241.09 88.4321L244.791 94.4461C244.919 94.6123 245.02 94.6473 245.071 94.649C245.184 94.6541 245.248 94.5921 245.369 94.3816L248.269 88.8901C248.526 88.4131 248.958 88.4193 248.958 88.4193H251.051L251.049 85.7027H247.781C247.186 85.7027 246.889 86.2156 246.889 86.2156Z",
			fill: "#F2B014"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 207.616,
			cy: 33.2731,
			r: 4.25456,
			fill: "#5C4610"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 184.924,
			cy: 33.2731,
			r: 4.25456,
			fill: "#5C4610"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 230.307,
			cy: 33.2731,
			r: 4.25456,
			fill: "#5C4610"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 252.999,
			cy: 33.2731,
			r: 4.25456,
			fill: "#5C4610"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 162.233,
			cy: 33.2731,
			r: 4.25456,
			fill: "#5C4610"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 183.506,
			y: 12,
			width: 2.83637,
			height: 21.2728,
			rx: 1,
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 228.891,
			y: 12,
			width: 2.83637,
			height: 21.2728,
			rx: 1,
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 251.58,
			y: 12,
			width: 2.83637,
			height: 21.2728,
			rx: 1,
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 206.197,
			y: 12,
			width: 2.83637,
			height: 21.2728,
			rx: 1,
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 160.816,
			y: 12,
			width: 2.83637,
			height: 21.2728,
			rx: 1,
			fill: "#EAEAEA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.699 115.527C135.699 126.027 139.405 134.665 153.081 134.726",
			stroke: "#EAEAEA",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.9359 65.8163L69.2476 64.4514C69.285 64.2876 69.3316 64.1259 69.3872 63.9663C69.4651 63.7926 69.5278 63.6442 69.575 63.5209C69.6405 63.4019 69.7284 63.2688 69.8386 63.1216C69.9711 62.9604 70.066 62.8385 70.1232 62.7558C70.1804 62.6731 70.3025 62.5574 70.4897 62.4087C70.6768 62.26 70.7948 62.1625 70.8437 62.1162C70.8967 62.0517 71.035 61.9492 71.2586 61.8088C71.4863 61.6502 71.6113 61.5639 71.6336 61.5499C71.6783 61.5218 71.8237 61.4305 72.0696 61.276C72.3196 61.1034 72.4558 61.01 72.4782 60.996C72.9336 60.6788 73.2905 60.4156 73.5488 60.2066C73.8072 59.9975 74.0731 59.7136 74.3465 59.3548C74.6381 59.0002 74.8276 58.6318 74.9149 58.2496C75.0687 57.5763 74.987 57.0119 74.6697 56.5565C74.3749 56.0871 73.8999 55.7776 73.2447 55.6279C72.1347 55.3744 71.1125 55.6579 70.1784 56.4785L68.1276 53.5113C68.9432 52.8743 69.8923 52.4496 70.9747 52.2373C72.0795 52.011 73.187 52.0246 74.2971 52.2781C75.9349 52.6522 77.2028 53.4301 78.1009 54.6117C78.999 55.7934 79.2548 57.2304 78.8682 58.9228C78.5025 60.5243 77.3331 61.9134 75.3602 63.0903C75.2261 63.1746 74.9711 63.327 74.5952 63.5475C74.2235 63.7498 73.9594 63.9001 73.8029 63.9984C73.6688 64.0826 73.4858 64.2131 73.2539 64.3899C73.022 64.5668 72.8489 64.7378 72.7346 64.9032C72.6244 65.0503 72.5394 65.2128 72.4796 65.3907L72.1024 66.5395L68.9359 65.8163ZM69.1047 72.7479C68.4677 72.6024 67.9787 72.2705 67.6375 71.7522C67.3005 71.2157 67.2027 70.638 67.344 70.0193C67.4812 69.4188 67.816 68.9591 68.3483 68.6403C68.903 68.3075 69.4897 68.2117 70.1085 68.353C70.709 68.4902 71.1778 68.827 71.5148 69.3636C71.8559 69.8819 71.9579 70.4413 71.8207 71.0418C71.6794 71.6606 71.3405 72.1384 70.804 72.4754C70.2716 72.7942 69.7052 72.885 69.1047 72.7479Z",
			fill: "#272728"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.3823 55.0204L60.9089 54.0218C60.8521 53.9019 60.802 53.779 60.7585 53.6528C60.722 53.507 60.6884 53.3844 60.6575 53.2849C60.64 53.1791 60.6294 53.0536 60.6259 52.9085C60.6293 52.7438 60.6286 52.6219 60.6237 52.5427C60.6188 52.4635 60.638 52.3321 60.6814 52.1484C60.7248 51.9648 60.7504 51.8467 60.7581 51.7941C60.7595 51.7282 60.7952 51.5972 60.8652 51.4009C60.929 51.1913 60.9643 51.0767 60.9713 51.0571C60.9853 51.0178 61.0309 50.8903 61.1079 50.6744C61.1786 50.4452 61.2175 50.3208 61.2245 50.3011C61.352 49.882 61.4448 49.5445 61.5029 49.2887C61.561 49.0328 61.5872 48.7269 61.5815 48.3709C61.5891 48.0085 61.5267 47.6875 61.3942 47.4079C61.1607 46.9153 60.8343 46.6052 60.4152 46.4777C60.003 46.3307 59.5573 46.3707 59.078 46.5979C58.2657 46.9829 57.7704 47.6579 57.5919 48.6231L54.8709 47.7847C55.0656 46.9913 55.4467 46.2644 56.0142 45.6041C56.5888 44.9241 57.2822 44.3916 58.0944 44.0067C59.2927 43.4387 60.459 43.3017 61.593 43.5958C62.7271 43.8899 63.5876 44.6561 64.1745 45.8944C64.7299 47.0662 64.6832 48.4988 64.0346 50.1922C63.9926 50.31 63.9089 50.529 63.7835 50.8493C63.6518 51.1563 63.5615 51.3785 63.5124 51.5159C63.4704 51.6337 63.4207 51.804 63.3633 52.0269C63.3059 52.2498 63.2821 52.4404 63.2919 52.5988C63.2955 52.7439 63.3221 52.8862 63.3719 53.0256L63.6991 53.9223L61.3823 55.0204ZM64.8725 59.2364C64.4065 59.4573 63.9411 59.4903 63.4764 59.3355C63.0054 59.1674 62.6626 58.857 62.448 58.4043C62.2398 57.9649 62.2228 57.5164 62.3972 57.0587C62.5787 56.5813 62.8957 56.2354 63.3484 56.0208C63.7878 55.8125 64.243 55.7925 64.7141 55.9606C65.1788 56.1153 65.5153 56.4124 65.7235 56.8518C65.9381 57.3045 65.9613 57.7664 65.7932 58.2374C65.6188 58.6951 65.3119 59.0281 64.8725 59.2364Z",
			fill: "#2F2E2E"
		})
	]
});
const ForwardRef = forwardRef(SvgQualificationBaselineValidationDark);
export default ForwardRef;
